/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { logger } from '@/utils/loggerUtils';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useAuthentication } from '@vimond/features/authentication';
import { getEnvVar } from '@vimond/utils/env';
import { useEffect, useState } from 'react';

let datadogEnabled = false;

export const RealUserMonitoring = () => {
  const { email } = useAuthentication();
  const [datadogRum, setDatadogRum] = useState<any>();
  const [datadogLogs, setDatadogLogs] = useState<any>();

  const environment = getEnvVar('NEXT_PUBLIC_ENVIRONMENT');
  const tenant = getEnvVar('NEXT_PUBLIC_TENANT');
  const env = `${tenant}-${environment}`;

  useEffect(() => {
    if (!email) return;
    if (datadogRum) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      datadogRum.setUser({
        email,
      });
    }
    if (datadogLogs) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      datadogLogs.setUser({
        email,
      });
    }
  }, [email, datadogRum, datadogLogs]);

  useEffect(() => {
    // do not run analytics on localhost
    if (window.location.hostname === 'localhost') return;

    import('@datadog/browser-rum')
      .then((datadog) => {
        const datadogRum = datadog.datadogRum;
        datadogRum.init({
          applicationId: '727278c7-cae3-4a23-a976-3e4667d66544',
          clientToken: 'pub1f2a879d73462b803dfaa1990f0bee85',
          site: 'datadoghq.com',
          service: 'vimond-via-webapp',
          env,
          sessionSampleRate: parseInt(
            getEnvVar('NEXT_PUBLIC_DATADOG_RUM_SAMPLE_RATE') ?? '0.1',
            10,
          ),
          sessionReplaySampleRate: parseInt(
            getEnvVar('NEXT_PUBLIC_DATADOG_RUM_REPLAY_SAMPLE_RATE') ?? '0.1',
            10,
          ),
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input',
        });
        setDatadogRum(datadogRum);
        datadogEnabled = true;
      })
      .catch((err) => logger.error('Failed to load datadogRum', err));
    import('@datadog/browser-logs')
      .then((datadog) => {
        const datadogLogs = datadog.datadogLogs;
        datadogLogs.init({
          // TODO: use secret from env
          clientToken: 'pub1f2a879d73462b803dfaa1990f0bee85',
          site: 'datadoghq.com',
          service: 'vimond-via-webapp',
          env,
          forwardErrorsToLogs: true,
          sessionSampleRate: parseInt(
            getEnvVar('NEXT_PUBLIC_DATADOG_LOGS_SAMPLE_RATE') ?? '100',
            10,
          ),
        });
        setDatadogLogs(datadogLogs);
        datadogEnabled = true;
      })
      .catch((err) => logger.error('Failed to load datadogLogs', err));
  }, [env]);

  return <></>;
};

export const addError = ({
  context = {},
  error,
  message = 'Error',
}: {
  context?: any;
  error?: any;
  message?: string;
}) => {
  if (datadogEnabled) {
    datadogRum.addError(error);
    // temp
    const m = `${message} ${JSON.stringify(context)}`;
    datadogLogs.logger.error(m, context, error);
  }
};

export const addLog = ({
  context = {},
  message,
}: {
  message: string;
  context?: any;
}) => {
  if (datadogEnabled) {
    datadogRum.addAction(message, context);
    // temp
    const m = `${message} ${JSON.stringify(context)}`;
    datadogLogs.logger.info(m, context);
  }
};
